import { render, staticRenderFns } from "./idxFooter01.vue?vue&type=template&id=4348d8e6&"
import script from "./idxFooter01.vue?vue&type=script&lang=js&"
export * from "./idxFooter01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports